/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
/* eslint-disable new-cap */
import { createSlice } from '@reduxjs/toolkit';
import { removeIntegrationThunk } from '../thunks/integration';
import { activeInactiveDayThunk, createEventLinkThunk, createGoogleMeetingThunk, deleteCalendarLinkThunk, deleteMeetingThunk, fetchAllTimeZonesThunk, fetchCalendarLinkNotificaitonThunk, fetchCalendarReminderThunk, fetchCustomTimeOfDateThunk, fetchDaysThunk, fetchGoogleEventsThunk, fetchMeetingNotificaitonsThunk, fetchRecentMeetingsThunk, fetchUserTimeZoneThunk, saveDaysThunk, updateCalenderLinkThunk, updateCustomTimeOfDateThunk, updateTimeThunk } from '../thunks/calendar';
import { AvailabilityHoursObject, CalendarEventObject, CalendarNotificaitonObject, CalendarState, WeeklyDayObject } from '../../params/redux/calendar';
import { transformedEvents, transformedReminders } from '../../helper/extract_events';

// Initial state with default values for authentication and user info
const initialState: CalendarState = {
    transformedEvents: [],
    recentMeetings: [],
    events: [],
    selectedTransformedEvent: null,
    selectedEvent: null,
    addEvent: false,
    addMeeting: false,
    calendarReminders: [],
    notificationDetails: {
        notifications: [],
        selectedNotification: null
    },
    slots: {
        selectedTab: 0,
        weeklyDay: [],
        customHours: {
            date: '',
            times: [],
            makeMeNotAvailable: false
        }
    },
    timezoneDetails: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        allTimezones: []
    },
    flags: {
        isSettingAvailability: false,
        isEditNotifications: false,
        isEditEventsForm: false
    },
    loaders: {
        isLoading: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const googleCalendarSlice = createSlice({
    // Slice name
    name: 'calendar',
    // inital state for the slice
    initialState,
    reducers: {
        settingSelectedEvent: (state, action) => {
            state.selectedEvent = action.payload;
        },
        settingSelectedTabForAvailability: (state, action) => {
            state.slots.selectedTab = action.payload;
        },
        settingAvailabilityFlag: (state, action) => {
            state.flags.isSettingAvailability = action.payload;
        },
        settingEditEventFormFlag: (state, action) => {
            state.flags.isEditEventsForm = action.payload;
        },
        settingEditNotificationFlag: (state, action) => {
            state.flags.isEditNotifications = action.payload;
        },
        settingAddingGoogleEvent: (state, action) => {
            state.addEvent = action.payload;
        },
        settingAddingGoogleMeeting: (state, action) => {
            state.addMeeting = action.payload;
        },
        settingCalendarSelectedNotification: (state, action) => {
            state.notificationDetails.selectedNotification = action.payload;
        },
        // Resets loading states related to app actions
        resettingGoogleCalendarLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingGoogleCalendarData: () => initialState
    },
    extraReducers: (builder) => {
        // Handle async actions for login
        builder
            .addCase(fetchGoogleEventsThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
                state.events = [];
                state.transformedEvents = [];
            })
            .addCase(fetchGoogleEventsThunk.fulfilled, (state, action) => {
                const values = action.payload as CalendarEventObject[];
                state.events = values;
                state.transformedEvents = transformedEvents(values);
            })
            .addCase(fetchGoogleEventsThunk.rejected, (state) => {
                state.events = [];
                state.transformedEvents = [];
            });
        builder
            .addCase(removeIntegrationThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isDeleting = true;
            })
            .addCase(removeIntegrationThunk.fulfilled, () => {
                //
            })
            .addCase(removeIntegrationThunk.rejected, () => {
                //
            });
        builder
            .addCase(fetchDaysThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(fetchDaysThunk.fulfilled, (state, action) => {
                state.slots.weeklyDay = action.payload as WeeklyDayObject[];
            })
            .addCase(fetchDaysThunk.rejected, (state) => {
                state.slots.weeklyDay = [];
            });
        builder
            .addCase(saveDaysThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(saveDaysThunk.fulfilled, () => {
                //
            })
            .addCase(saveDaysThunk.rejected, () => {
                //
            });
        builder
            .addCase(activeInactiveDayThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(activeInactiveDayThunk.fulfilled, () => {
                //
            })
            .addCase(activeInactiveDayThunk.rejected, () => {
                //
            });
        builder
            .addCase(updateTimeThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(updateTimeThunk.fulfilled, () => {
                //
            })
            .addCase(updateTimeThunk.rejected, () => {
                //
            });
            builder
            .addCase(fetchCustomTimeOfDateThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(fetchCustomTimeOfDateThunk.fulfilled, (state, action) => {
                const results = action.payload as {
                    availability_hours: AvailabilityHoursObject[];
                    custom_day	: {
                        date: string;
                        make_me_not_available: 'enabled' | 'disabled';
                    } | null
                };
                if (results.custom_day === null) {
                    state.slots.customHours.date = '';
                    state.slots.customHours.makeMeNotAvailable = false;
                } else {
                    state.slots.customHours.date = results.custom_day.date;
                    state.slots.customHours.makeMeNotAvailable = results.custom_day.make_me_not_available === 'enabled';
                }
                state.slots.customHours.times = results.availability_hours;
            })
            .addCase(fetchCustomTimeOfDateThunk.rejected, (state) => {
                state.slots.customHours = {
                    date: '',
                    times: [],
                    makeMeNotAvailable: false
                };
            });
            builder
            .addCase(updateCustomTimeOfDateThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(updateCustomTimeOfDateThunk.fulfilled, () => {
                //
            })
            .addCase(updateCustomTimeOfDateThunk.rejected, () => {
                //
            });
            builder
            .addCase(fetchAllTimeZonesThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(fetchAllTimeZonesThunk.fulfilled, (state, action) => {
                state.timezoneDetails.allTimezones = action.payload as {
                    zone: string;
                    time: string;
                }[];
            })
            .addCase(fetchAllTimeZonesThunk.rejected, (state) => {
                state.timezoneDetails.allTimezones = [];
            });
            builder
            .addCase(fetchUserTimeZoneThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(fetchUserTimeZoneThunk.fulfilled, (state, action) => {
                state.timezoneDetails.timezone = (action.payload as string) || Intl.DateTimeFormat().resolvedOptions().timeZone;
            })
            .addCase(fetchUserTimeZoneThunk.rejected, (state) => {
                state.timezoneDetails.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            });
            builder
            .addCase(fetchMeetingNotificaitonsThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(fetchMeetingNotificaitonsThunk.fulfilled, (state, action) => {
                state.notificationDetails.notifications = action.payload as CalendarNotificaitonObject[];
            })
            .addCase(fetchMeetingNotificaitonsThunk.rejected, (state) => {
                state.notificationDetails.notifications = [];
            });
            builder
            .addCase(fetchCalendarLinkNotificaitonThunk.pending, () => {
                // Set loading flag during login request
            })
            .addCase(fetchCalendarLinkNotificaitonThunk.fulfilled, (state, action) => {
                state.notificationDetails.notifications = action.payload as CalendarNotificaitonObject[];
            })
            .addCase(fetchCalendarLinkNotificaitonThunk.rejected, (state) => {
                state.notificationDetails.notifications = [];
            });
            builder
            .addCase(updateCalenderLinkThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isUpdating = true;
            })
            .addCase(updateCalenderLinkThunk.fulfilled, () => {
                //
            })
            .addCase(updateCalenderLinkThunk.rejected, () => {
                //
            });
            builder
            .addCase(deleteCalendarLinkThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isDeleting = true;
            })
            .addCase(deleteCalendarLinkThunk.fulfilled, () => {
                //
            })
            .addCase(deleteCalendarLinkThunk.rejected, () => {
                //
            });
            builder
            .addCase(deleteMeetingThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isDeleting = true;
            })
            .addCase(deleteMeetingThunk.fulfilled, () => {
                //
            })
            .addCase(deleteMeetingThunk.rejected, () => {
                //
            });
            builder
            .addCase(fetchCalendarReminderThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(fetchCalendarReminderThunk.fulfilled, (state, action) => {
                const data = action.payload as {
                    id: number;
                    deal_id: number;
                    title: string;
                    description: string;
                    due_date: string;
                    due_time: string;
                    status: 'active' | 'inactive';
                    created_at: string;
                    updated_at: string;
                }[];
                state.calendarReminders = transformedReminders(data);
            })
            .addCase(fetchCalendarReminderThunk.rejected, (state) => {
                state.calendarReminders = [];
            });
            builder
            .addCase(createEventLinkThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isCreating = true;
            })
            .addCase(createEventLinkThunk.fulfilled, () => {
                //
            })
            .addCase(createEventLinkThunk.rejected, () => {
                //
            });
            builder
            .addCase(createGoogleMeetingThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isCreating = true;
            })
            .addCase(createGoogleMeetingThunk.fulfilled, () => {
                //
            })
            .addCase(createGoogleMeetingThunk.rejected, () => {
                //
            });
            builder
            .addCase(fetchRecentMeetingsThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(fetchRecentMeetingsThunk.fulfilled, (state, action) => {
                state.recentMeetings = action.payload as CalendarEventObject[];
            })
            .addCase(fetchRecentMeetingsThunk.rejected, (state) => {
                state.recentMeetings = [];
            });
    }
});

// Exporting actions for updating app state
export const {
    settingCalendarSelectedNotification,
    settingSelectedTabForAvailability,
    settingEditEventFormFlag,
    settingEditNotificationFlag,
    settingAvailabilityFlag,
    settingSelectedEvent,
    resettingGoogleCalendarData,
    resettingGoogleCalendarLoader,
    settingAddingGoogleEvent,
    settingAddingGoogleMeeting
} = googleCalendarSlice.actions;

// Exporting the reducer to be used in the store
export default googleCalendarSlice.reducer;
